import { ReactElement, useMemo } from 'react';
import { useGetVehicleGroupsQuery } from '@customer/store/apis/metadataApi';
import BadgeList from '@cas/components/tables/cells/badge-list/BadgeList';
import { EmptyCell } from '../../formatters/genericFormatters';

interface AssetGroupCellRendererProps {
  value: number[];
}

export function AssetGroupCellRenderer({
  value,
}: AssetGroupCellRendererProps): ReactElement | string {
  const { data: assetGroups } = useGetVehicleGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const vehicleGroups = useMemo<string[]>(() => {
    if (assetGroups && value) {
      const orderedGroups: string[] = [];

      value.forEach(id => {
        const match = assetGroups.find(g => g.id === id);
        if (match && match.n) {
          orderedGroups.push(match.n);
        }
      });

      // Ensure in alphabetical order
      return orderedGroups.sort((a, b) => a[1].localeCompare(b[1]));
    }

    return [];
  }, [value, assetGroups]);

  return vehicleGroups.length ? <BadgeList items={vehicleGroups} /> : EmptyCell;
}

export default AssetGroupCellRenderer;
